interface TeamMember {
  first_name: string;
  last_name: string;
  role?: string;
  type?: string;
}

interface InvestmentTeamCardProps {
  teamMembers?: TeamMember[];
}

export function InvestmentTeamCard({ teamMembers }: InvestmentTeamCardProps) {
  if (!teamMembers || teamMembers.length === 0) return null;

  // Show role if available, otherwise show access type (capitalized)
  const getDisplayLabel = (member: TeamMember) => {
    if (member.role) return member.role;
    if (member.type) {
      return member.type.charAt(0).toUpperCase() + member.type.slice(1);
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h3 className="text-base sm:text-lg font-semibold text-black mb-4">
        Investment Team
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {teamMembers.map((member, index) => {
          const displayLabel = getDisplayLabel(member);
          return (
            <div key={index} className="flex items-center gap-3 min-w-0">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-medium text-xs sm:text-sm shrink-0">
                {member.first_name?.charAt(0) || ""}
                {member.last_name?.charAt(0) || ""}
              </div>
              <div className="flex flex-col min-w-0">
                <span className="font-medium text-black text-sm sm:text-base truncate">
                  {member.first_name} {member.last_name}
                </span>
                {displayLabel && (
                  <span className="text-xs sm:text-sm text-gray-500 truncate">
                    {displayLabel}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
